/* v26 (2026-10-27): Dex sells subscriptions, so there is no cart. On a plan's page, "Subscribe" empties the cart,
   puts that plan in it (with its monthly subscription plan, from the form) and opens the checkout straight away.
   Only forms marked data-dex-direct (snippets/buy-buttons.liquid: products that need a subscription plan) do this;
   if Shopify refuses (sold out, unavailable), the reason shows in the form's error line and nothing else changes.
   A sold-out plan's button is disabled, and then nothing is added at all. */
(function () {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('submit', async function (event) {
    const form = event.target;
    const wrap = form instanceof HTMLFormElement ? form.closest('[data-dex-direct]') : null;
    if (!wrap) return;
    // Before the theme's own product form script, which would open the cart drawer.
    event.preventDefault();
    event.stopImmediatePropagation();

    const button = form.querySelector('[type="submit"]');
    // Sold out (the plans before launch): nothing goes into a cart.
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const errorBox = wrap.querySelector('.product-form__error-message-wrapper');
    const errorText = wrap.querySelector('.product-form__error-message');
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    }
    if (errorBox) errorBox.hidden = true;

    try {
      await fetch(root + 'cart/clear.js', {method: 'POST', headers: {Accept: 'application/json'}});
      const res = await fetch(root + 'cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form)});
      const data = await res.json().catch(function () { return {}; });
      if (!res.ok) throw new Error(data.description || data.message || '');
      window.location.href = root + 'checkout';
    } catch (err) {
      if (errorBox && errorText) {
        errorText.textContent = (err && err.message) || wrap.getAttribute('data-dex-error') || '';
        errorBox.hidden = false;
      }
      if (button) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
    }
  }, true);
})();
